import React from "react";
import HelmetComponent from "./HelmetComponent";

function ListingGuidelines(props) {
  return (
    <div className=" min-h-screen flex flex-col justify-between">
      <HelmetComponent
        title="Akerayu | Listing Quality Policy"
        description="Stand out from the crowd! Follow Akerayu's Listing Quality Policy for successful property listings."
        imageUrl="https://akerayu.com/emailImages/logo.png"
        pageUrl="https://akerayu.com/listing-guidelines"
        type="website"
        robots="index, follow"
      />

      <div className="w-7/12 max-sm:w-full m-auto">
        <div className="max-w-3xl mx-auto px-4 py-8">
          <h1 className="text-3xl font-bold mb-4 text-main-orange">
            Akerayu Listing Quality Policy
          </h1>
          <p className="mb-4">Updated May 20, 2024</p>

          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-2 underline">
              1. Listing Submission Guidelines
            </h2>
            <ul className="list-none list-inside">
              <li>
                <p className="mb-2">
                  <span className="font-semibold">a. Listing Accuracy:</span>{" "}
                  Listings must provide accurate and complete information about
                  the property, including the address, property type, price (for
                  sale or rent), number of bedrooms, bathrooms, and kitchen
                  details. If privacy is a concern, landlords have the option to
                  utilize the "Hide My Location" feature on the platform to
                  conceal the address online.
                </p>
              </li>
              <li>
                <p className="mb-2">
                  <span className="font-semibold">b. Listing Features:</span>{" "}
                  Include all relevant features of the property, such as
                  amenities (e.g., WiFi, parking), utilities, and special
                  attributes.
                </p>
              </li>
              <li>
                <p className="mb-2">
                  <span className="font-semibold">c. Property Title:</span>{" "}
                  Ensuring a concise, catchy, and descriptive title for your
                  property is crucial in capturing the attention of potential
                  tenants and expediting the rental process.
                </p>
              </li>
              <li>
                <p className="mb-2">
                  <span className="font-semibold">d. Image Quality:</span>{" "}
                  Upload at least one high-quality image of the property. It's
                  recommended to include at least five high-quality images from
                  different angles to enhance the visibility of your listing and
                  attract potential tenants quickly. Stock or internet images
                  are not allowed.
                </p>
              </li>
              <li>
                <p className="mb-2">
                  <span className="font-semibold">e. Description:</span> Provide
                  a detailed description of the property, highlighting its
                  unique features and qualities. Avoid using promotional
                  language or misleading information.
                </p>
              </li>
              <li>
                <p className="mb-2">
                  <span className="font-semibold">f. Contact Information:</span>{" "}
                  Include a valid phone number for potential tenants to contact
                  the landlord. Social media contact details are optional.
                </p>
              </li>
            </ul>
          </div>

          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-2 underline">
              2. Compliance and Prohibited Listings
            </h2>
            <ul className="list-none list-inside">
              <li>
                <p className="mb-2">
                  <span className="font-semibold">a. Address Disclosure:</span>{" "}
                  Complete addresses are required to authenticate listings.
                  Incomplete addresses may result in the removal of the listing.
                  In cases where privacy is a priority, landlords can use the
                  "Hide My Location" feature on the platform, which allows them
                  to keep the address confidential when listing online.
                </p>
              </li>
              <li>
                <p className="mb-2">
                  <span className="font-semibold">b. Prohibited Content:</span>{" "}
                  Listings containing prohibited content, including
                  discriminatory language or illegal activities, will be
                  removed.
                </p>
              </li>
            </ul>
          </div>

          <div>
            <h2 className="text-xl font-semibold mb-2 underline">3. Quality Assurance</h2>
            <ul className="list-none list-inside">
              <li>
                <p className="mb-2">
                  <span className="font-semibold">a. Listing Feeds:</span>{" "}
                  Ensure listing feeds include complete and accurate data,
                  including photos and descriptions, updated at least once per
                  week.
                </p>
              </li>
              <li>
                <p className="mb-2">
                  <span className="font-semibold">b. Code of Conduct:</span>{" "}
                  Treat all users with respect and refrain from discriminatory
                  behavior or actions that may harm others.
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ListingGuidelines;
